module.exports = __webpack_public_path__ + "static/media/Cavern.dff7fcac.wav";